import { GAME } from '@/utils/game'

export default [
  {
    title: 'breadcrumb.report',
    header: 'breadcrumb.report',
    icon: '',
    children: [
      {
        title: 'breadcrumb.cockBalanceReport',
        route: 'cock-balance-report',
        icon: '',
        resource: 'balance-report',
        action: 'read',
      },
      {
        title: 'breadcrumb.baccaratBalanceReport',
        route: 'baccarat-balance-report',
        icon: '',
        resource: 'balance-report',
        action: 'read',
      },
      {
        title: 'breadcrumb.slotBalanceReport',
        route: 'slot-balance-report',
        icon: '',
        resource: 'balance-report',
        action: 'read',
        game: GAME.Joker,
      },
      {
        title: 'breadcrumb.lottoBalanceReport',
        route: 'lotto-balance-report',
        icon: '',
        resource: 'balance-report-lotto',
        action: 'read',
        game: GAME.Lotto,
      },
      {
        title: 'breadcrumb.lotto12BalanceReport',
        route: 'lotto12-balance-report',
        icon: '',
        resource: 'balance-report-lotto12',
        action: 'read',
        game: GAME.Lotto12,
      },
      {
        title: 'breadcrumb.lotteryBalanceReport',
        route: 'lottery-balance-report',
        icon: '',
        resource: 'balance-report-lottery',
        action: 'read',
        game: GAME.Vn99,
      },
      {
        title: 'breadcrumb.balanceReportSport99',
        route: 'balance-report-sport99',
        icon: '',
        resource: 'balance-report-sport99',
        action: 'read',
        game: GAME.Sport99,
      },
    ],
  },
]
